import React, { useState } from 'react';
import {
  TextField,
  Typography,
  InputAdornment,
  IconButton,
} from '@mui/material';
import { Dismiss12Filled } from '@fluentui/react-icons';

const TextInput = ({
  label,
  placeholder,
  value,
  onChange,
  sx,
  type = 'text',
  leadingIcon,
  trailingIcon,
  onIconClick,
  required,
  disabled = false,
}) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div style={{ width: '100%' }}>
      {label &&
      <Typography
        variant="body2"
        sx={{
          textAlign: 'left',
          color: isFocused ? 'var(--navyBlue-default)' : 'var(--black)',
          transition: 'color 0.2s ease-in-out',
          fontWeight: '500',
          marginBottom: 0.5,
        }}
      >
        {label}
      </Typography>}

      <TextField
        variant="outlined"
        fullWidth
        placeholder={placeholder}
        type={type}
        value={value}
        onChange={onChange}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        InputProps={{
          startAdornment: leadingIcon ? (
            <InputAdornment position="start" sx={{ marginRight: "-14px" }}>
              <IconButton
                onClick={onIconClick}
                sx={{ color: 'var(--gray-400)' }}
              >
                {leadingIcon}
              </IconButton>
            </InputAdornment>
          ) : null,
          endAdornment: trailingIcon ? (
            <InputAdornment position="end">
              <IconButton
                onClick={onIconClick}
                edge="end"
                sx={{ color: 'var(--gray-400)', padding: '10px' }}
              >
                {trailingIcon}
              </IconButton>
              
            </InputAdornment>
          ) : null,
          sx: {
            borderRadius: '10px',
            backgroundColor: 'var(--white)',
            fontSize: '1rem',
            height: '45px',
            // color: 'var(--navyBlue-default)',
            '& fieldset': {
              borderColor: 'var(--gray-300)',
            },
            '&:hover fieldset': {
              borderColor: 'var(--gray-300) !important',
            },
            '&.Mui-focused fieldset': {
              borderColor: 'var(--navyBlue-default) !important',
            },
            '& .MuiOutlinedInput-input': {
              padding: '13px 13px',
            },
            '&.Mui-disabled': {
              backgroundColor: 'var(--gray-100)',
              color: 'var(--gray-300)',
              cursor: 'not-allowed',
              '& fieldset': {
                borderColor: 'var(--gray-300) !important',
              },
            },
            
          },
        }}
        sx={sx}
        required={required ?? false}
        disabled={disabled ?? false}
      />
    </div>
  );
};

export default TextInput;
